import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWysiwyg = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2m0 16H5V7h14zm-2-7H7v-2h10zm-4 4H7v-2h6z" />
  </SvgIcon>
);

export default IconWysiwyg;



// WEBPACK FOOTER //
// ./src/components/icons/IconWysiwyg.js